export const handleIsStepAvailable = (
  workFlow: number,
  layer: number,
  layerAvailable: number,
  canAct: boolean,
) => {
  switch (workFlow) {
    case 3:
      return canAct ? layer >= layerAvailable : layer > layerAvailable
    case 4:
      return canAct ? layer >= layerAvailable + 1 : layer > layerAvailable + 1
  }
  return false
}

export const handleIsNextAvailableWithRole = (
  workFlow: number,
  layer: number,
  layerAvailable: number,
  currentTicketHolder: string,
  canAct: boolean,
  userRole: string,
) => {
  if (workFlow === 1 || workFlow === 2 || workFlow === 5) {
    return false
  }

  if (layer === 4) {
    return canAct
  } else {
    return workFlow == 3 ? layer >= layerAvailable : layer >= layerAvailable + 1
  }
}
